
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke403aRequest, Sgke403aResponse, Sgke403aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke403aService {

  /**
   * コンストラクタ
   * @param {Sgke403aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke403aService
   */
  constructor(
    public service: Sgke403aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE403A_欠損承認依頼・最終承認登録・承認API呼び出し
   * @param {Sgke403aRequest} request 
   * @returns {Observable<Sgke403aResponse>}
   * @memberof UsedSgke403aService
   */
  public doSgke403a(request: Sgke403aRequest): Observable<Sgke403aResponse> {
    return this.service.sgke403aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE403A');
          return throwError(err.message);
        })
      );
  }

}
